import { isKibouBiTypeFastest } from '@/constants/yusouKibouBiType'
import { isKibouJikanReason } from '@/constants/yusouKibouJikanType'

/**
 * 輸送希望日・時間の表示制御Mixin（履歴詳細用）
 */
export default {
  computed: {
    /** 引取希望日時が表示されるか */
    isHikitoriKibouDateTimeVisible() {
      return !isKibouBiTypeFastest(
        this.syaryoDetail.jyucyu_HIKITORI_KIBOU_BI_TYPE
      )
    },

    /** 引取希望時間の理由が表示されるか */
    isHikitoriKibouJikanReasonVisible() {
      return isKibouJikanReason(
        this.syaryoDetail.jyucyu_HIKITORI_KIBOU_JIKAN_TYPE
      )
    },

    /** 納車希望日時が表示されるか */
    isNosyaKibouDateTimeVisible() {
      return !isKibouBiTypeFastest(this.syaryoDetail.jyucyu_NOSYA_KIBOU_BI_TYPE)
    },

    /** 納車希望時間の理由が表示されるか */
    isNosyaKibouJikanReasonVisible() {
      return isKibouJikanReason(this.syaryoDetail.jyucyu_NOSYA_KIBOU_JIKAN_TYPE)
    },
  },
}



// WEBPACK FOOTER //
// ./src/components/mixin/history/YusouKibouMixin.js